var $ = require('jquery');

window.SlickUtilities = {
    Initialize: function (obj, settings) {
        var isPageEditor = window.SitecoreUtilities.isPageEditor;

        if (!isPageEditor()) {
            $(obj).slick(settings);
        }
    }
}